import { PropTypes } from 'prop-types';

export const userSerialiser = (user) => ({
  emailAddress: user?.email_address,
  userId: user?.user_id,
});

export const userDataPropTypes = {
  emailAddress: PropTypes.string,
  userId: PropTypes.string,
};
